// The backend formats every error message as "<status> Error: <message>",
// and the axios interceptor rejects with that text as the Error message.
const STATUS_PREFIX = /^(\d{3}) Error: /;

export const stripStatusPrefix = (message: string): string =>
  message.replace(STATUS_PREFIX, '');

/**
 * The backend's own explanation for a 4xx failure (for example "Email
 * already taken"), or the fallback for any other failure.
 */
export const clientErrorMessage = (err: unknown, fallback: string): string => {
  const message = err instanceof Error ? err.message : '';
  const status = message.match(STATUS_PREFIX)?.[1];
  if (status && status.startsWith('4')) {
    return stripStatusPrefix(message) || fallback;
  }
  return fallback;
};
